// src/__internal__/utils/isBrowser.ts
import { isServer } from "./isServer.mjs";
function isBrowser() {
  return !isServer();
}
export {
  isBrowser
};
